import { Controller } from "@hotwired/stimulus"

// Keyboard navigation through a triage run: left and right step to the previous
// and next card of the list the reader came from, Escape returns to that list.
// Deliberately nothing else — no shortcut performs an action, so a stray
// keystroke can never snooze or void a card.
export default class extends Controller {
  static values = { previous: String, next: String, back: String }

  initialize() { this.onKeydown = this.onKeydown.bind(this) }
  connect() { document.addEventListener("keydown", this.onKeydown) }
  disconnect() { document.removeEventListener("keydown", this.onKeydown) }

  onKeydown(event) {
    if (event.metaKey || event.ctrlKey || event.altKey || event.shiftKey) return
    if (this.isTyping(event.target) || this.hasOpenDialog()) return

    const path = this.pathFor(event.key)
    if (!path) return

    event.preventDefault()
    Turbo.visit(path)
  }

  pathFor(key) {
    if (key === "ArrowLeft") return this.previousValue
    if (key === "ArrowRight") return this.nextValue
    if (key === "Escape") return this.backValue
    return null
  }

  // A caret in a field owns the arrow keys, and so does an open menu or dialog:
  // Escape there means "close this", not "leave the card".
  isTyping(target) {
    if (!target) return false
    if (target.isContentEditable) return true
    return ["INPUT", "TEXTAREA", "SELECT"].includes(target.tagName)
  }

  // Escape means "close this" while anything is open on top of the card — a
  // modal, a disclosure, or one of the menus the action row hangs off. Without
  // those menus here, closing the snooze or overflow menu also left the card.
  //
  // The disclosure check is scoped to the card on purpose: the shell's own
  // pickers are native <details> that stay open after a click elsewhere, and a
  // page-wide check let one of those deaden the arrow keys until a full reload.
  hasOpenDialog() {
    return Boolean(
      document.querySelector("dialog[open]") ||
      document.querySelector("[data-flyout-menu-target='menu']:not([hidden])") ||
      document.querySelector("[data-snooze-menu-target='menu']:not([hidden])") ||
      this.element.querySelector("details[open]") ||
      this.element.querySelector("[data-action-confirm-target='dialog']:not([hidden])")
    )
  }
}
